import type { Price } from '@backmarket/http-api'
import type {
  CartItem,
  PromoCode,
} from '@backmarket/nuxt-layer-checkout/api/cart/types'

type CartItemWithPromoCodes = CartItem & {
  promoCodes: PromoCode[]
}

function isCartItemWithPromoCodes(
  item: CartItem,
): item is CartItemWithPromoCodes {
  return Array.isArray(item.promoCodes)
}

export function getItemsWithEligiblePromoCodes(
  items: CartItem[],
): CartItemWithPromoCodes[] {
  return items.filter(isCartItemWithPromoCodes).filter((item) => {
    if (item.available === 'no') return false

    return item.promoCodes.some((code) => code.eligible)
  })
}

export function getFlashSalesErrorType(items: CartItem[]): string | null {
  for (const item of items) {
    if (!item.promoCodes || item.available === 'no') continue

    const ineligiblePromoCode = item.promoCodes.find((code) => !code.eligible)
    if (ineligiblePromoCode?.errorType) {
      return ineligiblePromoCode.errorType
    }
  }

  return null
}

export function getEligiblePromoCode(items: CartItem[]): PromoCode | null {
  const itemsWithEligibleCodes = getItemsWithEligiblePromoCodes(items)

  for (const item of itemsWithEligibleCodes) {
    const eligiblePromoCode = item.promoCodes.find((code) => code.eligible)
    if (eligiblePromoCode) {
      return eligiblePromoCode
    }
  }

  return null
}

export function getFlashSalesDiscount(items: CartItem[]): Price | null {
  const eligiblePromoCode = getEligiblePromoCode(items)

  if (!eligiblePromoCode) return null

  return eligiblePromoCode.discountAmount
}
